const previewParamsBuilder = () => {
	const question = document.getElementsByClassName('question');
	const params = {};
	if (question.length) {
		const id = question[0].getAttribute("id");
		params.question = id.split('-').pop();
	}
	const darkModeSwitch = document.getElementsByClassName('darkModeSwitch');
	if (darkModeSwitch) {
		if (darkModeSwitch.checked) {
			params.darkmode = true;
		}
	}
	const endingCard = document.getElementsByClassName('ending-card');
	if (endingCard.length) {
		params.endingpage = true;
	}

	const currentLangElement = document.getElementById('language-flag');
	if (currentLangElement) {
		let currentLang = currentLangElement.getAttribute('current-lang');
		if (currentLang) {
			params.lang = currentLang;
		}
	}

	return params
}
const sendMessageToPreview = (validate, afterTimeout) => {
	setTimeout(() => {
		const params = previewParamsBuilder();
		if (validate) {
			params.validate = validate;
		}
		window.parent.postMessage(params, "*");
		afterTimeout()
	}, 1000);
}

export default sendMessageToPreview;